<template>
  <div class="main-wrap" @click="handleLink" :class="item.css_class"></div>
</template>

<script>
import api from '@/api'
export default {
    props: {
        item: Object
    },
    methods: {
        async handleLink () {
            try {
                const res = await api.getClickLink(this.item.link);
                if (this.item.type === 'bbb_external') window.open(res.data.joinUrl, '_blank');
                else if (this.item.type === 'bbb_modal') this.EventBus.$emit('open-html-modal', {
                    ...this.item,
                    customUrl: res.data.joinUrl
                });
            } catch (error) {
                console.warn(error);
            }
        }
    }
}
</script>

<style scoped lang='scss'>
.main-wrap {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
